import { RouteObject } from 'react-router-dom';

import { RootLayout } from '../../components/layouts/RootLayout';
import VirtualAssistant from './screens/VirtualAssistant';

const virtualAssistantRoutes: RouteObject[] = [
  {
    path: '/virtual-assistant',
    element: <RootLayout stickyImportantInformation />,
    children: [
      {
        path: '/virtual-assistant/pill/:action/:pillText',
        element: <VirtualAssistant />,
      },
      {
        path: '/virtual-assistant',
        element: <VirtualAssistant />,
      },
      {
        path: '/virtual-assistant/search/:searchQuery',
        element: <VirtualAssistant />,
      },
      {
        path: '/virtual-assistant/search',
        element: <VirtualAssistant />,
      },
      {
        path: '/virtual-assistant/:action',
        element: <VirtualAssistant />,
      },
    ],
  },
];

export default virtualAssistantRoutes;
